import React from 'react'
import { BtSelect } from '@linqpal/components/src/ui'
import { observer } from 'mobx-react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'

function validate(value) {
  return !!value && (value as []).length > 0
}

const options = [
  'Electrical, Solar, Low Voltage',
  'Plumbing, Pipeline, and Fire Protection',
  'Framing and Rough Carpentry Contractor',
  'Roofing and Waterproofing',
  'Countertop fabricator and Installation',
  'Landscaping, Paving, Earthwork',
  'Finish Carpentry, Cabinet and Millwork',
  'Drywall and Plaster',
  'Concrete and Foundation',
  'Insulation and Acoustical',
  'Appliance Installation',
  'Ceramic and Mosaic Tile',
  'Flooring and Floor Covering',
  'Lathing and Plastering',
  'Masonry',
  'Painting and Decorating',
  'Structural Steel, Reinforcing Steel, and Sheet Meta',
  'Swimming Pool',
  'Glazing, Glass and Mirror',
  'Elevator',
  'Other',
]

const initialValue: string[] | null = []

function Trade(props) {
  const { t } = useTranslation('application')
  const { doc, group, item, onValueUpdate, review } = props
  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    initialValue,
    validate,
  )

  return (
    <BtSelect
      model={model}
      placeholder={t('Business.TradePlaceholder')}
      label={t('Business.TradeLabel')}
      options={options}
      primitiveArray
      multiSelect
      size="large"
      name="value"
      testID="BusinessTradeInput"
      style={{ marginTop: review ? 24 : 0 }}
    />
  )
}

export default {
  title: 'Business.Trade',
  description: 'Business.TradeDescription',
  showFooterMessage: true,
  component: observer(Trade),
}
